import { faArrowDownToLine } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ExportButton = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();
  return (
    <Button
      size="large"
      className="text-sm"
      icon={<FontAwesomeIcon icon={faArrowDownToLine} />}
      onClick={onClick}
    >
      {t('button.export')}
    </Button>
  );
};

export default ExportButton;
